import { forwardRef } from 'react';
import { StyledGrid } from './styled';

const Grid = forwardRef((props, ref) => <StyledGrid ref={ref} {...props} />);

export default Grid;
